import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { and, eq, notEq } from 'ember-truth-helpers';

interface PrismToggleSignature {
  Args: {
    dataTestId?: string;
    isChecked?: boolean;
    isDisabled?: boolean;
    isSmall?: boolean;
    label?: string;
    labelPosition?: 'before' | 'after';
    name?: string;
    onChange?: (value: boolean) => unknown;
    value?: string;
  };
  Element: HTMLInputElement;
}

export default class PrismToggle extends Component<PrismToggleSignature> {
  @action handleClick(event: MouseEvent): void {
    const target = event.target as HTMLInputElement;

    this.args.onChange?.(target.checked);
  }

  <template>
    <label
      class="prism-toggle
        {{if
          @isSmall
          'prism-toggle--small text-200--regular'
          'text-300--regular'
        }}
        {{if @isDisabled 'prism-toggle--disabled'}}"
    >
      {{#if (and @label (eq @labelPosition "before"))}}
        {{@label}}
      {{/if}}

      <input
        checked={{@isChecked}}
        data-test-id={{@dataTestId}}
        disabled={{@isDisabled}}
        name={{@name}}
        type="checkbox"
        value={{@value}}
        {{on "click" this.handleClick}}
      />

      <span class="prism-toggle__slider"></span>

      {{#if (and @label (notEq @labelPosition "before"))}}
        {{@label}}
      {{/if}}
    </label>
  </template>
}
